import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import connect from '../../core/EcrionProvider/connect';
import Moment from 'moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment'; //Considers user time zone like DateTimeFormatter | centralize everything here

export var Types = ['datetime', 'date', 'time'];
export var Variants = {
  short: {
    time: 'h:mm A',
    date: 'MMM DD',
    datetime: 'MMM DD h:mm A'
  },
  long: {
    time: 'h:mm:ss A',
    date: 'MMM DD YYYY',
    datetime: 'MMM DD YYYY h:mm:ss A'
  }
};

var getUtils = function getUtils(timezone) {
  var _temp;

  return _temp =
  /*#__PURE__*/
  function (_MomentUtils) {
    _inherits(EcrionMomentUtils, _MomentUtils);

    function EcrionMomentUtils() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, EcrionMomentUtils);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(EcrionMomentUtils)).call.apply(_getPrototypeOf2, [this].concat(args)));
      _this.dateFormat = Variants.long.date;
      _this.dateTime12hFormat = Variants.long.datetime;
      _this.time12hFormat = Variants.long.time;
      return _this;
    }

    _createClass(EcrionMomentUtils, [{
      key: "date",
      value: function date(value) {
        var mom = Moment(value);
        if (value && value.keepTime) mom.tz(timezone, true);else mom.tz(timezone);
        return mom;
      }
    }]);

    return EcrionMomentUtils;
  }(MomentUtils), _temp;
};
/**
 * @extends {React.Component<import('./types').TimezoneLoaderProps> }
 */


var TimezoneLoader =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TimezoneLoader, _React$Component);

  function TimezoneLoader(props) {
    var _this2;

    _classCallCheck(this, TimezoneLoader);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(TimezoneLoader).call(this, props));

    _this2.props.onChange(_this2.props.timezone);

    return _this2;
  }

  _createClass(TimezoneLoader, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevState) {
      if (this.props.timezone === prevState.timezone) return; // nothing changed

      this.props.onChange(this.props.timezone);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return TimezoneLoader;
}(React.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var timezone = _ref.userInfo.timezone;
  return {
    timezone: timezone
  };
};

var EcrionTimezoneLoader = connect(mapStateToProps)(TimezoneLoader);
/**
 * @extends {React.Component<import('./types').DateTimeProviderProps> }
 */

var DateTimeProvider =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(DateTimeProvider, _React$Component2);

  function DateTimeProvider(props) {
    var _this3;

    _classCallCheck(this, DateTimeProvider);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(DateTimeProvider).call(this, props));

    _this3.setTimezone = function (timezone) {
      _this3.setState({
        utils: getUtils(timezone)
      });

      Moment.timezone = timezone;
    };

    _this3.state = {
      utils: getUtils()
    };
    return _this3;
  }

  _createClass(DateTimeProvider, [{
    key: "render",
    value: function render() {
      return React.createElement(React.Fragment, null, React.createElement(EcrionTimezoneLoader, {
        onChange: this.setTimezone
      }), React.createElement(MuiPickersUtilsProvider, {
        utils: this.state.utils
      }, this.props.children));
    }
  }]);

  return DateTimeProvider;
}(React.Component);

export default DateTimeProvider;